import { WMICVehicleUtil } from 'wmic-pe-portals-utils-js';

export default {
    isCommerciallyRatedVehicleType: (businessSegmentType, vehicleType) =>
        WMICVehicleUtil.isCommerciallyRatedVehicleType(businessSegmentType.code, vehicleType.code),
};
